import React from 'react';

import {
  MotifHeader,
  MotifVerticalNavigationHeaderButton as MotifVerticalNavHeaderButton,
  MotifMenu,
} from '@ey-xd/motif-react';
import ey_Logo from '@assets/icons/ey_Logo.png';
import { isMobile } from 'react-device-detect';
import '@styles/commonStyles.css';

const NavbarAccessRestriction = () => {
  const logo = !isMobile ? <img src={ey_Logo} alt="EY Logo" /> : null;

  return (
    <MotifHeader
      className="navbar-header"
      logo={logo}
      leftComponents={
        isMobile ? <MotifVerticalNavHeaderButton className="mobile-hamberg-menu" /> : null
      }
      appHeaderName="Sales Forecasting"
      iconsContainer={
        isMobile ? <MotifMenu openFromLeft variant="alt" className="mobile-menu"></MotifMenu> : null
      }
    />
  );
};

export default NavbarAccessRestriction;
